import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AiSearchConversationView } from "./AiSearchConversationView";
import { AiSearchConversationViewStore } from "../../store/AiSearchConversationViewStore";
import { useStore } from "../../../../hooks";

export const AiSearchConversationViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/aiSearchConversation/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AiSearchConversationViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AiSearchConversationView aiSearchConversationViewStore={store} />
      </PageLayout>
    </div>
  );
});
